module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.haveLabel) ? _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    staticClass: "weui-input text-right",
    class: {
      'pr-15': _vm.clearIcon
    },
    attrs: {
      "type": _vm.inputType,
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.inputEvent
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "deleteIcon"
    },
    on: {
      "mousedown": function($event) {
        _vm.clean($event)
      }
    }
  }, [(_vm.showClean) ? _c('i', {
    staticClass: "s-icon-times-circle"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._t("foot")], 2)]) : _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('input', {
    staticClass: "weui-input",
    attrs: {
      "type": _vm.inputType,
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.inputEvent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('i', {
    staticClass: "s-icon-cancel",
    on: {
      "click": function($event) {
        _vm.cancelText()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-795cdf60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-cell-input/index.vue
// module id = 1063
// module chunks = 2